import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
var ConditionService = /** @class */ (function () {
    function ConditionService(router) {
        this.router = router;
        this.cond = {};
        this.resetFlg = false;
    }
    ConditionService.prototype.setResetFlg = function (flg) {
        this.resetFlg = flg;
    };
    ConditionService.prototype.getResetFlg = function () {
        return this.resetFlg;
    };
    ConditionService.prototype.resetCondition = function () {
        this.cond = {};
        sessionStorage.removeItem('condition');
    };
    ConditionService.prototype.setCondition = function (cond, url) {
        if (url === void 0) { url = this.router.url; }
        this.cond[url] = cond;
        sessionStorage.setItem('condition', JSON.stringify(this.cond));
    };
    ConditionService.prototype.getCondition = function (url) {
        if (url === void 0) { url = this.router.url; }
        if (Object.keys(this.cond).length === 0) {
            var cond = sessionStorage.getItem('condition');
            this.cond = {};
            if (cond) {
                this.cond = JSOG.parse(cond);
            }
        }
        return this.cond[url];
    };
    ConditionService.prototype.deleteCondition = function (url) {
        if (url === '/member/member_search') {
            var cond = this.getCondition(url);
            if (typeof cond !== 'undefined' && typeof cond['$memberSearchGroup'] !== 'undefined' && typeof cond['$memberSearchGroup']['mode'] !== 'undefined') {
                delete cond['$memberSearchGroup']['mode'];
            }
            this.setCondition(cond, url);
        }
    };
    ConditionService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ConditionService.ctorParameters = function () { return [
        { type: Router }
    ]; };
    return ConditionService;
}());
export { ConditionService };
//# sourceMappingURL=condition.service.js.map